// extracted by mini-css-extract-plugin
export default {"ToggleSwitch":"ToggleSwitch_ToggleSwitch__8h2Bi","Checkbox":"ToggleSwitch_Checkbox__ndi3v","Label":"ToggleSwitch_Label__Y7w5e","Thumb":"ToggleSwitch_Thumb__-6jN7"};